import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'
import { canUseTours } from './tourUi'
import tourManager from './TourManager'
import demoSession from './demo/DemoSession'

const AUTO_SHOWN_KEY = 'hdv_intro_auto_shown'

const deveExibirBoasVindas = (me) => me?.is_tour_concluido === false

export const persistIsTourConcluido = (isTourConcluido) => {
    const userInfo = auth.getUserInfo() || {}
    const anterior = userInfo.is_tour_concluido
    userInfo.is_tour_concluido = isTourConcluido
    auth.setUserInfo(userInfo, true)

    return axios({
        method: 'patch',
        url: cfg.base_api_url + cfg.api_v2 + '/me/',
        data: JSON.stringify({ is_tour_concluido: isTourConcluido }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + auth.getToken(),
        },
    }).catch((error) => {
        userInfo.is_tour_concluido = anterior
        auth.setUserInfo(userInfo, true)
        throw error
    })
}

export const bindNaoMostrarNovamente = () => {
    const checkbox = document.querySelector('[data-hdv-nao-mostrar-novamente]')
    if (!checkbox || checkbox._hdvBound) return

    checkbox._hdvBound = true
    checkbox.checked = auth.getUserInfo()?.is_tour_concluido === true

    const stopTourGesture = (event) => {
        event.stopPropagation()
    }

    const label = checkbox.closest('.hdv-tour-nao-mostrar')
    const targets = [checkbox, label].filter(Boolean)

    targets.forEach((target) => {
        target.addEventListener('mousedown', stopTourGesture)
        target.addEventListener('pointerdown', stopTourGesture)
        target.addEventListener('click', stopTourGesture)
    })

    checkbox.addEventListener('change', (event) => {
        event.stopPropagation()
        if (checkbox.disabled) return

        const naoMostrar = checkbox.checked
        checkbox.disabled = true

        persistIsTourConcluido(naoMostrar)
            .catch(() => {
                checkbox.checked = !naoMostrar
            })
            .finally(() => {
                checkbox.disabled = false
            })
    })
}

export const maybeAutoStartBoasVindas = (me) => {
    if (!canUseTours() || !deveExibirBoasVindas(me)) return
    if (demoSession.isActive() || tourManager.isActive()) return
    if (tourManager.getMinimizedState()?.tourName) return

    try {
        if (sessionStorage.getItem(AUTO_SHOWN_KEY) === '1') return
        sessionStorage.setItem(AUTO_SHOWN_KEY, '1')
    } catch (error) {}

    tourManager.start('boas-vindas')
}
